import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationLink } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-evernorth-header',
  templateUrl: './evernorth-header.component.html',
  styleUrls: ['./evernorth-header.component.scss'],
})
export class EvernorthHeaderComponent {
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() userid = '';
  @Input() profileLinks: NavigationLink[] = [];

  @Input() isMessageCenterEnabled = false;
  @Input() isImpersonator = false;
  @Input() isAuthenticated = false;
  @Input() isNavigationDisabled = false;
  @Input() isResourceLibraryApp = false;
  @Input() isResourceResults = false;
  @Input() isLogoLinkInternal = true;
  @Input() logoLink = '';

  @Output() logOut = new EventEmitter();

  constructor() {}
}
